import { injectScript, loadOnlyApp } from './browserApp';

// Tidio's live chat and chatbots: one script named by the project's public key.
// https://help.tidio.com/hc/en-us

// Loads Tidio's widget for the project, once.
const install = (settings: Record<string, string | boolean>): void => {
  const publicKey = String(settings.publicKey || '');
  if (!/^[a-z0-9]{20,40}$/.test(publicKey)) return;
  injectScript('xshop-tidio', `https://code.tidio.co/${publicKey}.js`);
};

export const tidioApp = loadOnlyApp(install);
